import React from 'react';
import PropTypes from 'prop-types';

import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';
import SrSimpleMessageModal, {
  SR_SIMPLE_MESSAGE_MODAL_THEME_SLIDE_UP,
} from 'client/components/SrSimpleMessageModal/SrSimpleMessageModal';

import {
  SR_BUTTON_THEME_ADOBE_GREY,
  SR_BUTTON_THEME_ADOBE_YELLOW,
} from 'client/components/SrButton/SrButton';

const SrUtilitySetupChangeAddressModal = ({ addressDisplay, onSubmit, onBack }) => {
  return (
    <SrSimpleMessageModal
      iconUrl="/images/emoji-warning.png"
      theme={SR_SIMPLE_MESSAGE_MODAL_THEME_SLIDE_UP}
      contentContainerClassName="utilityProviderContact"
      iconBgColor="#FFFBEB"
      maxWidth="320px"
      maxIconHeight="100px"
      maxIconWidth="100px"
      headline={
        <SrBox maxWidth="280px" margin="0 auto">
          <SrText fontSize="24px" weight="800" font="greycliff" display="block">
            Change address?
          </SrText>
        </SrBox>
      }
      underline
      message={
        <SrBox maxWidth="250px" margin="0 auto">
          <SrText
            font="greycliff"
            fontSize="16px"
            lineHeight="25px"
            weight="600"
            align="center"
            display="block"
          >
            📍 {addressDisplay}
          </SrText>
          <SrText
            font="greycliff"
            fontSize="16px"
            lineHeight="25px"
            weight="600"
            align="center"
            display="block"
            paddingTop="20px"
          >
            Changing your address will reset your utility setup. This is typical when you move to a
            new rental property.
          </SrText>
          <SrText
            font="greycliff"
            fontSize="16px"
            lineHeight="25px"
            weight="600"
            align="center"
            display="block"
            paddingTop="20px"
          >
            Are you sure you want to proceed with updating your address?
          </SrText>
        </SrBox>
      }
      srMultiButtons={[
        {
          buttonText: 'Confirm and Reset',
          onButtonClick: onSubmit,
          buttonTheme: SR_BUTTON_THEME_ADOBE_YELLOW,
        },
        {
          buttonText: 'Back',
          onButtonClick: onBack,
          buttonTheme: SR_BUTTON_THEME_ADOBE_GREY,
        },
      ]}
    />
  );
};

SrUtilitySetupChangeAddressModal.propTypes = {
  addressDisplay: PropTypes.string.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
};

SrUtilitySetupChangeAddressModal.displayName = 'SrUtilitySetupChangeAddressModal';

export default SrUtilitySetupChangeAddressModal;
